import { render, staticRenderFns } from "./TreatmentDwellTimePageTable.vue?vue&type=template&id=8920af6c"
import script from "./TreatmentDwellTimePageTable.vue?vue&type=script&lang=js"
export * from "./TreatmentDwellTimePageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports